export default {
  en: {
    termsOfPayment: 'Terms of Payment',
    editTermsOfPayment: 'Edit Terms of Payment',
    name: 'Name',
    description: 'Description',
    status: 'Status',
    save: 'Save Changes',
    cancel: 'Cancel',
    editSuccessTitle: 'Success',
    editSuccessMessage: 'Edit Terms of Payment Success'
  },
  th: {
    termsOfPayment: 'เงื่อนไขการชำระเงิน',
    editTermsOfPayment: 'แก้ไขเงื่อนไขการชำระเงิน',
    name: 'หัวข้อ',
    description: 'รายละเอียด',
    status: 'สถานะ',
    save: 'บันทึก',
    cancel: 'ยกเลิก',
    editSuccessTitle: 'สำเร็จ',
    editSuccessMessage: 'แก้ไขเงื่อนไขการชำระเงินสำเร็จ'
  }
}
